import { ClaimV2CornSchema } from '@eigtech/claims-v2-types';
import { ApiLambdalerAuthHeaderWithRequestActorSchema } from '@eigtech/lambdaler-api-gateway-types';
import { JobCornSchema } from '@eigtech/restoration-types';
import { z } from 'zod';
import { BaseLineItemSchema } from '../../base/base.js';
export const GenerateLineItemsApiSchema = {
    params: z.object({
        entityId: ClaimV2CornSchema.or(JobCornSchema),
    }),
    headers: ApiLambdalerAuthHeaderWithRequestActorSchema,
    response: z.object({ accepted: z.literal(true) }),
};
export const GenerateLineItemsPathSchema = GenerateLineItemsApiSchema.params;
export const GenerateLineItemsHeadersSchema = GenerateLineItemsApiSchema.headers;
export const GenerateLineItemsRequestSchema = z.object({
    ...GenerateLineItemsHeadersSchema.shape,
    ...GenerateLineItemsPathSchema.shape,
});
export const GenerateLineItemsResponseSchema = GenerateLineItemsApiSchema.response;
export const GenerateLineItemsWorkRequestSchema = z.object({
    entityId: ClaimV2CornSchema.or(JobCornSchema),
});
export const GenerateLineItemsWorkResponseSchema = z.object({
    lineItems: z.array(BaseLineItemSchema),
});
